<template>
  <div class="PageLayout">
    <div class="PageLayout__header">
      <div class="PageLayout__headerBg"></div>

      <div class="PageLayout__headerContent">
        <v-container>
          <h1><slot name="header" /></h1>
          <p>
            <slot name="subheader" />
          </p>
        </v-container>
      </div>
    </div>

    <v-container>
      <div style="width: 95%" class="mx-auto">
        <slot name="content" />
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PageLayout",
};
</script>

<style scoped>
.link {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.link:hover,
.link:active,
.link:focus {
  text-decoration: underline;
}

.PageLayout__header {
  position: relative;
  /* min-height: 200px; */
  overflow: hidden;
  /* margin-top: 300px; */
}

.PageLayout__headerBg {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f6f9fc;
  /* background-color: #c4c4c4; */
  transform: skewY(-4deg);
  transform-origin: top left;
}

.PageLayout__headerContent {
  position: relative;
  padding: 3vw 0 7vw 0;
}
</style>
